export default __webpack_public_path__ + "static/media/codenitiva.62ba8a94.png";